<template>
    <div>
        <div class="table-header row">
            <div>
                <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="selectAllChange"
                />
            </div>
            <div>
                网吧ID
            </div>
            <div>
                网吧名称
            </div>
            <div>
                管理组
            </div>
            <div>安全组</div>
            <div>防护状态</div>
            <div>无盘品牌</div>
            <div>计费品牌</div>
            <div>实名品牌</div>
            <div>文化品牌</div>
            <div>营销品牌</div>
            <div>操作</div>
        </div>
        <div class="table-body">
            <div
                class="row"
                v-for="(item, index) in safetyGroupList"
                :key="index"
            >
                <!-- 选中 -->
                <div>
                    <input
                        type="checkbox"
                        @click.stop
                        v-model="item.select"
                        @change="selectChange(item.select)"
                    />
                </div>
                <!-- 网吧ID -->
                <div>
                    <span v-text="item.barId"></span>
                </div>
                <!-- 网吧名称 -->
                <div>
                    <span v-text="item.barName"></span>
                </div>
                <!-- 管理组 -->
                <div>
                    <span v-text="item.groupName"></span>
                </div>
                <!-- 安全组 -->
                <div>
                    <span v-text="item.securityName"></span>
                </div>
                <!-- 防护状态 -->
                <div class="status">
                    <span
                        v-show="item.securitySwitch == 1"
                        style="background:rgba(3, 157, 18, 1)"
                        >防护中</span
                    >
                    <span
                        v-show="item.securitySwitch == 0"
                        style="background:rgba(170, 170, 170, 1)"
                        >已停止</span
                    >
                </div>
                <!-- 无盘品牌 -->
                <div>
                    <span v-text="item.disklessBrandName"></span>
                </div>
                <!-- 计费品牌 -->
                <div>
                    <span v-text="item.billingBrandName"></span>
                </div>
                <!-- 实名品牌 -->
                <div>
                    <span v-text="item.realNameBrandName"></span>
                </div>
                <!-- 文化品牌 -->
                <div>
                    <span v-text="item.cultureBrandName"></span>
                </div>
                <!-- 营销品牌 -->
                <div>
                    <span v-text="item.marketBrandName"></span>
                </div>
                <div class="operate">
                    <a
                        href="#"
                        v-show="item.securitySwitch == 1"
                        @click.prevent.stop="protectionStatus(item, 0)"
                        >关闭防护</a
                    >
                    <a
                        href="#"
                        v-show="item.securitySwitch == 0"
                        @click.prevent.stop="protectionStatus(item, 1)"
                        >开启防护</a
                    >
                    <a href="#" @click.prevent.stop="environmentSettings(item)"
                        >环境设置</a
                    >
                </div>
            </div>
            <no-data
                style="height:auto;padding-top:20px;padding-bottom:20px;"
                v-show="tableList.length == 0 || loading"
                :nodata="tableList.length == 0 && !loading"
                :loading="loading"
            ></no-data>
        </div>
        <div class="table-pagination" v-show="tableList.length > 0">
            <div style="float:left;padding-left:6px;">
                <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="selectAllChange"
                />
                <div class="default-btn com" @click.prevent="moveSecurityGroup">
                    <span>移动安全组</span>
                </div>
                <div
                    class="default-btn com"
                    @click.prevent="environmentSettingsAll"
                >
                    <span>设置环境</span>
                </div>
                <div
                    @click.prevent="protectionStatusAll(1)"
                    class="default-btn com"
                >
                    开启防护
                </div>
                <div
                    class="default-btn com"
                    @click.prevent="protectionStatusAll(0)"
                >
                    <span>关闭防护</span>
                </div>
            </div>
            <page-component
                :total="total"
                :display="30"
                :current-page="page"
                @pagechange="pagechange"
            ></page-component>
        </div>
    </div>
</template>

<script>
// 分页功能
import PageComponent from "_c/pagination/pageComponent";
import NoData from "_c/noData/noData";
export default {
    name: "tableData",
    components: {
        PageComponent,
        NoData
    },
    props: {
        tableList: {
            type: Array,
            default() {
                return [];
            }
        },
        total: {
            type: Number,
            default: 0
        },
        page: {
            type: Number,
            default: 0
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isSelectAll: false,
            safetyGroupList: []
        };
    },
    watch: {
        tableList() {
            this.isSelectAll = false;
            this.safetyGroupList = this.tableList.map(item => {
                item.select = false;
                return item;
            });
        }
    },
    methods: {
        selectedBarIds() {
            let arr = [];
            this.safetyGroupList.forEach(item => {
                if (item.select) {
                    arr.push(item.barId);
                }
            });
            return arr;
        },
        pagechange(page) {
            this.$emit("pagechange", page);
        },
        selectAllChange() {
            if (this.isSelectAll) {
                this.safetyGroupList.forEach(item => {
                    item.select = true;
                });
            } else {
                this.safetyGroupList.forEach(item => {
                    item.select = false;
                });
            }
        },
        selectChange(selectState) {
            if (selectState) {
                // 对单项进行选中
                // 判断是否全部选中
                let selectAllState = this.safetyGroupList.every(item => {
                    return item.select == true;
                });
                // 若全部选中,则为全选管理组
                if (selectAllState) {
                    this.isSelectAll = true;
                }
            } else {
                // 对单项进行取消
                this.isSelectAll = false;
            }
        },
        async protectionStatus(item, val) {
            this.$emit("openOrClose", item.barId, item.barName, val);
        },
        async environmentSettingsAll() {
            if (this.selectedBarIds().length == 0) {
                return window.$Message.show({
                    title: "提示",
                    type: "error",
                    msg: "请选择网吧"
                });
            }
            let res = await window.$modal.environmentSettings.show(
                this.selectedBarIds().join(","),
                1
            );
            if (res) {
                this.$emit("refresh");
            }
        },
        protectionStatusAll(val) {
            this.$emit("protectionStatusAll", val);
        },
        async environmentSettings(item) {
            let res = await window.$modal.environmentSettings.show(
                item.barId,
                2
            );
            if (res) {
                this.$emit("refresh");
            }
        },
        async moveSecurityGroup() {
            if (this.selectedBarIds().length == 0) {
                return window.$Message.show({
                    title: "提示",
                    type: "error",
                    msg: "请选择网吧"
                });
            }
            let res = await window.$modal.moveSafeGroup.show(
                this.selectedBarIds().join(",")
            );
            if (res) {
                this.$emit("refresh");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
    width: 100%;
    cursor: pointer;
    @include clearfix();
    &:after {
        content: "";
        top: 0;
        left: 0;
        display: block;
        font-size: 0;
        height: 0;
        width: 0;
        clear: both;
        visibility: hidden;
    }
    > div {
        float: left;
        text-align: left;
        text-overflow: ellipsis;
        height: 50px;
        span {
            @include ellipsis();
            max-width: 100%;
        }
        p {
            @include ellipsis();
            max-width: 100%;
        }
        a {
            display: inline;
            border-right: 1px solid #aaaaaa;
            text-align: left;
            text-indent: 0px;
            padding-right: 3px;
            margin-right: 3px;
            color: #02a7f0;
            &:last-child {
                border-right: none;
            }
        }
        input {
            cursor: pointer;
        }
    }

    > div:nth-child(1) {
        width: 22px;
        text-indent: 6px;
        input {
            position: relative;
            top: 2px;
        }
    }
    > div:nth-child(2) {
        width: 5%;
        @include ellipsis();
        text-align: left;
    }
    > div:nth-child(3) {
        width: 12%;
        @include ellipsis();
    }
    > div:nth-child(4) {
        width: 5%;
        @include ellipsis();
    }
    > div:nth-child(5) {
        width: 8%;
        @include ellipsis();
    }
    > div:nth-child(6) {
        width: 5%;
        @include ellipsis();
    }
    > div:nth-child(7) {
        width: 8%;
        @include ellipsis();
    }
    > div:nth-child(8) {
        width: 8%;
        @include ellipsis();
    }
    > div:nth-child(9) {
        width: 8%;
        @include ellipsis();
    }
    > div:nth-child(10) {
        width: 8%;
        @include ellipsis();
    }
    > div:nth-child(11) {
        width: 8%;
        @include ellipsis();
    }
    > div:nth-child(12) {
        width: 20%;
        @include ellipsis();
    }
}

.table-header {
    color: #333;
    > div {
        height: 30px;
        line-height: 30px;
    }
}

.bar-name {
    p {
        line-height: normal;
        line-height: 14px;
    }
    p:nth-child(1) {
        padding-top: 10px;
    }
}
.gray-word {
    color: $gray-word;
}
.server {
    .online {
        span {
            color: $green;
        }
    }
    .offline {
        span {
            color: $gray-word;
        }
    }
    img {
        position: relative;
        vertical-align: top;
        top: 18px;
        margin-right: 4px;
    }
}

.table-pagination {
    text-align: right;
    padding-right: 80px;
    padding-top: 20px;
    > div {
        display: inline-block;
        .com {
            margin-left: 10px;
            cursor: pointer;
        }
    }
}
input[type="checkbox"] {
    cursor: pointer;
}
.status {
    span {
        padding: 2px;
        border-radius: 2px;
        color: #fff;
    }
}
</style>
